import { render, staticRenderFns } from "./spa.vue?vue&type=template&id=2e031b91"
import script from "./spa.vue?vue&type=script&lang=js"
export * from "./spa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports